import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const DEFAULT_TITLE = "CivicHearth — Turn time into impact. Multiply the good.";
const PRODUCTION_ORIGIN = "https://civichearth.com";

export const Seo = ({ title, description, image }) => {
  const full = title ? `${title} · CivicHearth` : DEFAULT_TITLE;
  const { pathname } = useLocation();
  const canonical = `${PRODUCTION_ORIGIN}${pathname || "/"}`;
  // Per-page OG artwork with a site-wide default. The static index.html tags
  // deliberately do NOT set og:image — crawlers take the first one they see,
  // which would make page-specific images impossible.
  const ogImage = image || `${PRODUCTION_ORIGIN}/og-image.png`;
  return (
    <Helmet>
      <title>{full}</title>
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={full} />
      <meta property="og:url" content={canonical} />
      {description && <meta name="description" content={description} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};
